module.exports = __webpack_public_path__ + "static/media/kernelcon.d41c749e.svg";